import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { FC, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';

import { makeClient } from '../../src/lib/apollo';
import { ATTRIBUTES_TAG_KEY, DATA_TAG_KEY } from '../constants/tag';
import { extractDataFromTag } from '../utils/data';
import { parseData } from '../utils/data/parse';

interface Props<T> {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  attributes: T;
}

export const initializeClientApp = async <T,>(Component: FC<Props<T>>) => {
  const apolloClient = await makeClient({ ssr: false });
  const cacheData = parseData(extractDataFromTag(DATA_TAG_KEY));
  const attributes = parseData(extractDataFromTag(ATTRIBUTES_TAG_KEY)) as T;

  apolloClient.cache.restore(cacheData);

  hydrateRoot(
    document.getElementById('root') as HTMLElement,
    <StrictMode>
      <Component apolloClient={apolloClient} attributes={attributes} />
    </StrictMode>
  );
};
